import { Component, ViewChild, ElementRef, AfterViewInit,OnInit} from '@angular/core';
import { AlertController, TextInput } from 'ionic-angular';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ReCaptchaComponent } from 'angular2-recaptcha';
declare var jquery:any;
declare var $ :any;
declare var grecaptcha:any;
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

	  @ViewChild("formsubmission") formsubmissionField;
      @ViewChild('paymentohers') paymentohersField;
      @ViewChild('ReCaptchaComponent') captcha: ReCaptchaComponent;
      @ViewChild('divClick') divClick: ElementRef;


placeorder:any = {
	name: "",
	email:"",
	message:""
  };
	public shouldShow = false;templatewordress:boolean;templatewoocommerce:boolean=false;templatecmshtmlwoocommerce:boolean=false;customcmshtmlwoocommerce:boolean=false;custom:boolean;customtemplate:boolean;pagenoval:string;hideResetBtn:boolean=false;isPageReadOnly:boolean=false;oldpage:number; formnoError:boolean=false;captchatoken:string;bookingsystembol:boolean;shippingsystembol:boolean;userregbol:boolean;monthchangebol:boolean;monthchangeothersbol:boolean;psabol:boolean;vmbol:boolean;pmbol:boolean;paypalbol:boolean;otherpmbol:boolean;creditbol:boolean;storelocbol:boolean;productratebol:boolean;psadiffbol:boolean;custhtmlbol:boolean;custecombol:boolean;custcmsbol:boolean;tempbol:boolean;custbol:boolean;tempcmsbol:boolean;woocombol:boolean;magentbol:boolean;wordbol:boolean;Concrete5bol:boolean;
      forsubmval:number;orderbol:boolean;proretbol:boolean;shopcartingbol:boolean;acceptdonationbol:boolean;
     formSubmckeckbox:boolean;inputautofocus:boolean=false;paymentcheckothers:boolean;paymentcheckothersval:string;
    othersinputcls:boolean=false;logodesbol:boolean; pagedesignbol:boolean;respondesbol:boolean;sittingbanbol:boolean;formSubmckeckboxbol:boolean;photogalbol:boolean;videogalbol:boolean;seofrndbol:boolean;multisupportbol:boolean;emailnbol:boolean;forumbol:boolean;blogbol:boolean;livechbol:boolean;w3codebol:boolean;socialmediabol:boolean;delvalbol:boolean;goAnalbol:boolean;
	issavequotationenabled:boolean=false;isplaceorderenabled:boolean=false;
	result:number;name:any;email:any;useregistration:boolean=false;usebookingsystem:boolean=false;useshippingsystem:boolean=false;
	pageno:number;pageshow:string;
	template:number;step3:number;show1:string;show2:string; message:string; ordertype:string;
	
	//for ecommerce.....................................
	changesub:number;productwithsimilar:number;price:number; vprice:number;sprice:number;oprice:number;
	proprice:number;payprice:number;creprice:number;othprice:number;shopcart:number;acceptdon:number;strlocprice:number;prorate:number;
	
    show3:string;product:string;pm:string; vm:string;shipp:string;otrack:string;prodret:string;payp:string;credeitca:string;others:string;
	shopvalue:string;acceptvalue:string;strloc:string;proreview:string;
	
	//for CMS...........................................
	changeCmsPrice:number;pageprice:number;resprice:number;slideprice:number;photoprice:number;videoprice:number;seoprice:number;
	miltiLprice:number;emailprice:number;fprice:number;bprice:number;liveprice:number;calBprice:number;formSprice:number;regprice:number;
	fbprice:number;googlprice:number;linkprice:number;tweetprice:number;profprice:number;codeprice:number;mediaprice:number;
	delprice:number;anaprice:number;supportprice:number;forprice:number;val:number;
	
	show4:string;logods:string;pageval:string;response:string;slidebanner:string;formsubm:string;photog:string;videoembed:string;
	Sfrnd:string;multilingual:string;emailnews:string;forumval:string; blogval:string;livechat:string;calenderbook:string;bookform:string;
	useregestration:string;faceb:string;googlep:string;link:string;twit:string;profile:string;w3co:string;socialm:string;expdel:string;
	gogleanal:string;supportfor:string;
	
	//for html...........................................
	htmlogval:number;htmlpage:number;htmlres:number;htmlbanner:number;htmlGalry:number;htmlvideo:number;htmlSEO:number;htmlW3C:number;
	hmlsocialm:number;expresval:number;googleanal:number;supportVal:number;
	
	hLogoval:string;htmlval:string;htmldes:string;htmlslide:string;htmlphoto:string;htmlvembed:string;htmlsfrnd:string;w3cValidate:string;
	htmlsmedia:string;htmldeli:string;htmlgoogle:string;htmlsup:string;

	//for business...........................................
	demoval:number;demoval2:number;demoval3:number;demoval4:number;demoval5:number;
	demo1:string;demo2:string;demo3:string;demo4:string;demo5:string;

	ar:any=[false,false,false,false,false];
	group:number;
	parentNo:number;
	inputDisabled:boolean;
	buttonDisabled:boolean;
	constructor( public alertCtrl: AlertController,public http:Http ) {
			this.inputDisabled=false;
		 
	}
	

	//*****************ALERT POPUP TO SEND QUOTATION************************* */

	// Email validation ///
validateEmail(data) {
    if( /(.+)@(.+){2,}\.(.+){2,}/.test(data.email) ){
      return {
        isValid: true,
        message: ''
      };
    } else {
       return {
          isValid: false,
          message: 'Email address is required'
       }
    }
}

	clear(){
		this.name = "";
		this.email = "";
		this.message = "";
	}

	//
	
	insertInfo() {
		if(this.formSubmckeckbox){
			if(this.forsubmval>0 ){
                    
		let prompt = this.alertCtrl.create({
		  title: 'Send It',
		  subTitle: 'Enter the info to save & send',
		  message: "",
		  cssClass: 'sendAlert',
	      enableBackdropDismiss: false,
		  inputs: [
			{
		        name: 'name',
		        placeholder: 'Name',
				 type : 'text', 
		      },
		      {
		        name: 'email',
		        placeholder: 'Your Email',
				type : "email",  
			  }
		  ],
		  buttons: [
			{
				text: 'SEND',
				handler: data => {
					
                	let validateObj = this.validateEmail(data);
                	if(data.name==""){
                       prompt.setMessage('<div class="error">Please enter your name</div>');
                        return false;

                	}
                    else if (!validateObj.isValid) {
                        prompt.setMessage('<div class="error">Please enter valid email address</div>');
                        return false;
                    }else {
                        this.postQuatationRequest();
                        prompt.setMessage('<div class="success">You have successfully send quatation</div>');
	
							setTimeout(() => {
                                 prompt.dismiss()
							}, 4000);

                         return false;
                    }
				}
			},
			{
			  text: 'CANCEL',
			  handler: data => {
				console.log('Cancel clicked');
			  }
			}
		  ]
		});
		prompt.present();
                   return true;
			}else{
              this.formsubmissionField.setFocus();
             // this.formsubmissionField.setBackgroundColor(0x0000FF00 );
		      return false;
	   }
		
	}


		let prompt = this.alertCtrl.create({
		  title: 'Send It',
		  subTitle: 'Enter the info to save & send',
		  message: "",
		  cssClass: 'sendAlert',
	      enableBackdropDismiss: false,
		  inputs: [
			{
		        name: 'name',
		        placeholder: 'Name',
				 type : 'text', 
		      },
		      {
		        name: 'email',
		        placeholder: 'Your Email',
				type : "email",  
			  }
		  ],
		  buttons: [
			{
				text: 'SEND',
				handler: data => {
					
                	let validateObj = this.validateEmail(data);
                	if(data.name==""){
                       prompt.setMessage('<div class="error">Please enter your name</div>');
                        return false;

                	}
                    else if (!validateObj.isValid) {
                        prompt.setMessage('<div class="error">Please enter valid email address</div>');
                        return false;
                    }else {
                        this.postQuatationRequest();
                        prompt.setMessage('<div class="success">You have successfully send quatation</div>');
	
							setTimeout(() => {
                                 prompt.dismiss()
							}, 4000);

                         return false;
                    }
				}
			},
			{
			  text: 'CANCEL',
			  handler: data => {
				console.log('Cancel clicked');
			  }
			}
		  ]
		});
		prompt.present();
	  }


insertPlaceOrderInfo(event) {

	  	var self=this;
grecaptcha.ready(function() {
      grecaptcha.execute('6Lc9GpYUAAAAAFDtedRIJuoOxVJrBB08CMDgQBz7', {action: 'calculator'}).then(function(token) {
         self.captchatoken= token;

      });
  });
	  		if(this.formSubmckeckbox ){
			if(this.forsubmval>0 ){
		let prompt = this.alertCtrl.create({
		  title: 'Send It',
		  subTitle: 'Enter the info to save & send',
		  message: "",
		  cssClass: 'sendAlert',
	      enableBackdropDismiss: false,
		  inputs: [
			{
		        name: 'name',
		        placeholder: 'Full Name *',
				 type : 'text', 
		      },
		      {
		        name: 'email',
		        placeholder: 'Your Email *',
				type : "email",  
			  },
			
		  ],
		  buttons: [
			{
				text: 'SEND',
				handler: data => {
					//console.log('Send clicked');
					
                	let validateObj = this.validateEmail(data);
                	if(data.name==""){
                       prompt.setMessage('<div class="error">Please enter your name</div>');
                        return false;

                	}
                    else if (!validateObj.isValid) {
                        prompt.setMessage('<div class="error">Please enter valid email address</div>');
                        return false;
                    }else {
                    	this.name=data.name;
                    	this.email=data.email;
                    	//this.message=data.message;
                        this.postRequest();

                        prompt.setMessage('<div class="success">Thank you for using mejora web design calculator</div>');
                        setTimeout(() => {
                                 prompt.dismiss();
                                 location.reload();
							}, 4000);

                        return false;
                    }
  					
				}
			},
			{
			  text: 'CANCEL',
			  handler: data => {
				//console.log('Cancel clicked');
			  }
			}
		  ]
		});
			prompt.present();
			return true;

			}
		else{

				this.formsubmissionField.setFocus();
				this.formnoError=true;
		          return false;
			}

		}	
		let prompt = this.alertCtrl.create({
		  title: 'Send It',
		  subTitle: 'Enter the info to save & send',
		  message: "",
		  cssClass: 'sendAlert',
	      enableBackdropDismiss: false,
		  inputs: [
			{
		        name: 'name',
		        placeholder: 'Full Name *',
				 type : 'text', 
		      },
		      {
		        name: 'email',
		        placeholder: 'Your Email *',
				type : "email",  
			  },
		  ],
		  buttons: [
			{
				text: 'SEND',
				handler: data => {
					console.log('Send clicked');
					
                	let validateObj = this.validateEmail(data);
                	if(data.name==""){
                       prompt.setMessage('<div class="error">Please enter your name</div>');
                        return false;

                	}
                    else if (!validateObj.isValid) {
                        prompt.setMessage('<div class="error">Please enter valid email address</div>');
                        return false;
                    }else {

                    	this.name=data.name;
                    	this.email=data.email;
                    	//this.message=data.message;

                        this.postRequest();

                        prompt.setMessage('<div class="success">Thank you for using mejora web design calculator</div>');
                        setTimeout(() => {
                                 prompt.dismiss()
                                 location.reload();
							}, 4000);

                        return false;
                    }
  					
				}
			},
			{
			  text: 'CANCEL',
			  handler: data => {
				//console.log('Cancel clicked');
			  }
			}
		  ]
		});

		prompt.present();
	  }

	//*****************ALERT POPUP TO SEND QUOTATION************************* */

	toggleClick(event) {
		
		return 'in'
	}
	
	postRequest(){
		var chekwith=[];var signupwith=[];
		chekwith.push(this.payp,this.credeitca,this.others);
		signupwith.push(this.faceb,this.googlep,this.link,this.twit);
		
		var headers = new Headers();
		headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Access-Control-Allow-Headers', '*');
    	headers.append("Accept", 'application/json');
		headers.append('Content-Type', 'application/json' );
    	let options = new RequestOptions({ headers: headers });
		
		let postData={
			name:this.name,
			email:this.email,
			message:this.message,
			ordertype :'place order',
			captchatoken: this.captchatoken,
			total:this.result,
			page:this.pageshow,
			custemp:this.show1,
			option2:this.show2,
			option3:this.show3,
			product:this.product,
			Productm:this.pm,
			Vendorm:this.vm,
			ship:this.shipp,
			ordertrack:this.otrack,
			proreturn:this.prodret,
			shoppingcart:this.shopvalue,
			acptdonatn:this.acceptvalue,
			stloc:this.strloc,   
			checkoutwith:chekwith,
			productreview:this.proreview,
			
			show4:this.show4,
			logodesign:this.logods,
			pageval:this.pageval,
			responsede:this.response,
			skidebanner:this.slidebanner,
			formsubmission:this.formsubm,
			forsubcount:this.val,
			Photogallry:this.photog,
			videoembedded:this.videoembed,
			SEOfrnd:this.Sfrnd,
			multilingual:this.multilingual,
			emailnwz:this.emailnews,
			forumvalue:this.forumval,
			blogvalue:this.blogval,
			livachat:this.livechat,
			calenderbook:this.calenderbook,
			formbook:this.bookform,
			userregistration:this.useregestration,
			ownprofile:this.profile,
			w3code:this.w3co,
			socialmedia:this.socialm,
			delivery:this.expdel,
			googlanalysis:this.gogleanal,
			support:this.supportfor,
			signUpWith:signupwith,
			htmllog:this.hLogoval,
			htmlvalue:this.htmlval,
			htmldesign:this.htmldes,
			htnlslide:this.htmlslide,
			htmlPhoto:this.htmlphoto,
			htmlvideo:this.htmlvembed,
			htmlseofrnd:this.htmlsfrnd,
			w3cvalidate:this.w3cValidate,
			htmlmedia:this.htmlsmedia,
			hdelivery:this.htmldeli,
			hgoogle:this.htmlgoogle,
			htmlsup:this.htmlsup,
			
		}
        //console.log(postData);
    	this.http.post("http://mejorainfotech.com/web-design-cost-calculator/api.php", postData, options)
      	.subscribe(data => {
      			//console.log( data);

      	  //console.log('ok');
        	
       	}, error => {
        		//console.log(error);// Error getting the data
      	});
  	}


  	postQuatationRequest(){
		var chekwith=[];var signupwith=[];
		chekwith.push(this.payp,this.credeitca,this.others);
		signupwith.push(this.faceb,this.googlep,this.link,this.twit);
		
		var headers = new Headers();
		headers.append('Access-Control-Allow-Origin', '*');
    	headers.append("Accept", 'application/json');
		headers.append('Content-Type', 'application/json' );
    	let options = new RequestOptions({ headers: headers });
		
		let postData={
			name:this.name,
			email:this.email,
			total:this.result,
			ordertype :'Quatation',
			page:this.pageshow,
			custemp:this.show1,
			option2:this.show2,
			option3:this.show3,
			product:this.product,
			Productm:this.pm,
			Vendorm:this.vm,
			ship:this.shipp,
			ordertrack:this.otrack,
			proreturn:this.prodret,
			shoppingcart:this.shopvalue,
			acptdonatn:this.acceptvalue,
			stloc:this.strloc,   
			checkoutwith:chekwith,
			productreview:this.proreview,
			
			show4:this.show4,
			logodesign:this.logods,
			pageval:this.pageval,
			responsede:this.response,
			skidebanner:this.slidebanner,
			formsubmission:this.formsubm,
			forsubcount:this.val,
			Photogallry:this.photog,
			videoembedded:this.videoembed,
			SEOfrnd:this.Sfrnd,
			multilingual:this.multilingual,
			emailnwz:this.emailnews,
			forumvalue:this.forumval,
			blogvalue:this.blogval,
			livachat:this.livechat,
			calenderbook:this.calenderbook,
			formbook:this.bookform,
			userregistration:this.useregestration,
			ownprofile:this.profile,
			w3code:this.w3co,
			socialmedia:this.socialm,
			delivery:this.expdel,
			googlanalysis:this.gogleanal,
			support:this.supportfor,
			signUpWith:signupwith,
			htmllog:this.hLogoval,
			htmlvalue:this.htmlval,
			htmldesign:this.htmldes,
			htnlslide:this.htmlslide,
			htmlPhoto:this.htmlphoto,
			htmlvideo:this.htmlvembed,
			htmlseofrnd:this.htmlsfrnd,
			w3cvalidate:this.w3cValidate,
			htmlmedia:this.htmlsmedia,
			hdelivery:this.htmldeli,
			hgoogle:this.htmlgoogle,
			htmlsup:this.htmlsup,
			
		}
 
    	this.http.post("http://mejorainfotech.com/web-design-cost-calculator/quatation.php", postData, options)
      	.subscribe(data => {
      			//console.log( data);

      	 // console.log('ok');
        	
       	}, error => {
        		//console.log(error);// Error getting the data
      	});
  	}

	//to get the price..
	getval(){
		this.result=0;
		//if page con not be defined  
		if(this.pageno==null && this.template==null){
			this.result=0;
		}
		//if page no defined.............
		if(this.pageno!=null){
			if(this.pageno<=1 || this.pageno<=2){
				this.result=(90*this.pageno)+this.result;
			}else if(this.pageno>2 && this.pageno<=10){

                 this.result=(75*this.pageno)+this.result;
			}else if(this.pageno>10 && this.pageno<=20){

                 this.result=(60*this.pageno)+this.result;
			}else if(this.pageno>20){

                this.result=(50*this.pageno)+this.result;
			}else{

				this.result=0;
			}

			
		}
		//if template defined............
		if(this.template!=null){
			this.result=this.result+this.template;
		}
		//if cms ecommerce html or business application click.......
		if(this.step3!=null){
			//this.result=0;
			this.result=this.result + this.step3;
		}

		//woocommerce or magento clicked.........
		if(this.changesub!=null){
			this.result+=this.changesub;  
		}
		//if product with similar or product with different attribute clicked............... 
		if(this.productwithsimilar!=null){
			this.result+=this.productwithsimilar;
		}
		//if product managemnet clicked..............
		if(this.price>0){
			this.result+=this.price;
			
		}
		if(this.vprice>0){
			this.result+=this.vprice;
			
		}
		//if shipping radio button clicked...........
		if(this.sprice!=null){
			this.result=this.result+this.sprice;
		}
		//if order button clicked....................
		if(this.oprice>0){
			this.result+=this.oprice;
		}
		//if product retun clicked...................
		if(this.proprice>0){
			this.result+=this.proprice;
		}
		if(this.shopcart>0){
			this.result+=this.shopcart;
		}
		if(this.acceptdon>0){
			this.result+=this.acceptdon;
		}
			
		//if payprice retun clicked..................
		if(this.payprice>0){
			this.result+=this.payprice;
		}
		//if credits checkbox clicked................
		if(this.creprice>0){
			//console.log("before result",this.price);
			this.result+=this.creprice;
			//console.log("credit",this.result);
		}
		//if others clicked..........................
		if(this.othprice>0){
//			this.result=0;
////			console.log("result",this.othprice);
//			var res=this.othprice;
//			this.result=this.res;
			this.result+=this.othprice;
			//console.log(this.result);
		}
		
		if(this.strlocprice>0){
			this.result+=this.strlocprice;
		}
		if(this.prorate>0){
			this.result+=this.prorate;
		}
		
		
		//*****************************CMS************CMS********************************************//
		//if wordpress or joomla selected..............
		if(this.changeCmsPrice!=null){
			this.result+=this.changeCmsPrice;
		}
		//if pageprice selected....................................
		if(this.pageprice>0){
			this.result+=this.pageprice;
		}
		//if response design selected........................
		if(this.resprice>0){
			this.result+=this.resprice;
		}
		//	if sliding banner selected............	
		if(this.slideprice>0){
			this.result+=this.slideprice;
		}
		//if photogallry selected...............
		if(this.photoprice>0){
			this.result+=this.photoprice;
		}
		//if vedio embedding gallry selected..................
		if(this.videoprice>0){
			this.result+=this.videoprice;
		}
		//if form ang page selected............
		if(this.forprice>0 && this.val!=null){
			this.result+=(this.val*this.forprice);
		}
		//if SEOfreind selected...............................
		if(this.seoprice>0){
			this.result+=this.seoprice;
			//console.log("seo",this.result);
		}
		//if multilingual selected.................................
		if(this.miltiLprice>0){
			this.result+=this.miltiLprice;
		}
		//if email Newletter Selected
		if(this.emailprice>0){
			this.result+=this.emailprice;
		}
		//if forum clicked............		
		if(this.fprice>0){
			this.result+=this.fprice;
		}

		//if forum clicked............		
		if(this.bprice>0){
			this.result+=this.bprice;
		}
		//if live chat selected.....................................		
		if(this.liveprice>0){
			this.result+=this.liveprice;
		}
		//booking part....
		//calender booking selected............................
		if(this.calBprice>0){
			this.result+=this.calBprice;
		}
		//from submission selected................
		if(this.formSprice>0){
			this.result+=this.formSprice;
		}//end of booking part
		//if user registration selected................
		if(this.regprice>0){
			this.result+=this.regprice;
		}
		//sign up part********************
		//fb selected............
		if(this.fbprice>0){
			this.result+=this.fbprice;
		}
		//if google plus selected............
		if(this.googlprice>0){
			this.result+=this.googlprice;
		}
		//if linkdin selected...............
		if(this.linkprice>0){
			this.result+=this.linkprice;
		}
		//if twwitter selected..............
		if(this.tweetprice>0){
			this.result+=this.tweetprice;
		}
		//if own profile selected...........
		if(this.profprice>0){
			this.result+=this.profprice;
		}//sign up part end*******************
		
		//if w3c Code selected...............
		if(this.codeprice>0){
			this.result+=this.codeprice;
		}
		//if sign up media selected..........
		if(this.mediaprice>0){
			this.result+=this.mediaprice;
		}
		//if express delivery selected.........
		if(this.delprice>0){
			this.result+=this.delprice;
		}
		//if google analytics selected.........
		if(this.anaprice>0){
			this.result+=this.anaprice;
		}
		//if support for selected..............
		if(this.supportprice>0){
			this.result+=this.supportprice;
		}
		
		//*************************************** HTML *******************************************//
		//if first option selected.............
		if(this.htmlogval>0){
			this.result+=this.htmlogval;
		}
		//if secnd option selected.................
		if(this.htmlpage>0){
			this.result+=this.htmlpage;
		}
		//if third option selected..................
		if(this.htmlres>0){
			this.result+=this.htmlres;
		}
		if(this.htmlbanner>0){
			this.result+=this.htmlbanner;
		}
		if(this.htmlGalry>0){
			this.result+=this.htmlGalry;
		}
		if(this.htmlvideo>0){
			this.result+=this.htmlvideo;
		}	
		if(this.htmlSEO>0){
			this.result+=this.htmlSEO;
		}
		if(this.htmlW3C>0){
			this.result+=this.htmlW3C;
		}
		if(this.hmlsocialm>0){
			this.result+=this.hmlsocialm;
		}
		if(this.expresval>0){
			this.result+=this.expresval;
		}
		if(this.googleanal>0){
			this.result+=this.googleanal;
		}
		if(this.supportVal!=null){
			this.result+=this.supportVal;	
		}
		
		//*****************************  Business  ********************************************//
		//if demo1 Selected...........
		if(this.demoval>0){
			this.result+=this.demoval;
		}
		//if demo2 Selected...........
		if(this.demoval2>0){
			this.result+=this.demoval2;
		}
		//if demo3 selected............
		if(this.demoval3>0){
			this.result+=this.demoval3;   
		}
		//if demo4 selected........................
		if(this.demoval4>0){
			this.result+=this.demoval4;   
		}
		if(this.demoval5>0){
			this.result+=this.demoval5;
		}
		
		return this.result;
		
		//page con not be defined and only template selected 
		
//		else if(this.pageno==null && this.template!=null && this.step3==null){
//			this.result+=this.template;
//			
//			return this.result;
//		}
//		else if(this.pageno==null && this.template!=null && this.step3!=null && this.productwithsimilar==null  && this.changesub==null){
//			this.result=this.result+this.template+this.step3;
//			
//			return this.result;
//		}
//		else if(this.pageno==null && this.template!=null && this.step3!=null && this.changesub==null && this.productwithsimilar!=null){
//			this.result=this.result+this.template+this.step3+this.productwithsimilar;//this.changesub;
//			
//			return this.result;
//		}
//		else if(this.pageno==null && this.template!=null && this.step3!=null || this.changesub!=null && this.productwithsimilar!=null && this.price==null){
	}

	resetAllInfo(event){
		
		    this.group=0;
		    this.show1='';
		    this.hideResetBtn= false;
		    this.result=0;
		    this.templatewordress =false;
		    this.templatewoocommerce = false;
		    this.templatecmshtmlwoocommerce=false;
		    this.customcmshtmlwoocommerce=false;
		    this.customtemplate=false;
		    this.custom= false;
			this.pagenoval='';
			this.pageno=0;
			this.pageshow='';
			this.show1='';
			this.show2='';
			this.show3='';
			this.calenderbook='';
			this.bookform='';
			this.faceb='';
			this.googlep='';
			this.link='';
			this.twit='';
			this.isPageReadOnly = false;
			this.logodesbol= false; 
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
			this.formSubmckeckbox= false;
			this.photogalbol=false;
			this.videogalbol=false;
			this.seofrndbol=false;
			this.multisupportbol=false;
			this.emailnbol=false;
			this.forumbol=false;
			this.blogbol=false;
			this.livechbol=false;
			this.w3codebol=false;
			this.socialmediabol=false;
			this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
			this.shippingsystembol=false;
			this.userregbol=false;
			this.psabol=false;
			this.vmbol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
			this.psadiffbol=false;
			this.monthchangebol=false;
			this.monthchangeothersbol=false;
			this.custhtmlbol=false;
			this.custecombol=false;
			this.custcmsbol=false;
			this.tempbol=false;
			this.custbol=false;
			this.tempcmsbol=false;
			this.woocombol=false;
			this.magentbol=false;
			this.wordbol=false;
			this.Concrete5bol=false;
			this.forsubmval=0;
			this.formnoError=false;


	}
	//when page no is defined
	onChange(event){
		// if(oldpageno){
		// 	if(oldpageno!=event.target.value){
		// 			location.reload();
		// 			return false;
		// 		}
		// }
		this.pageno=event.target.value;
		this.issavequotationenabled=true;
		this.isPageReadOnly = true;
		this.hideResetBtn= true;
		if(this.pageno){
			this.pageshow=this.pageno+' pages website';
		}
		else{
			this.pageshow='';
		}
	}
	
	//step2// call the func for custom or template 
	changevalue(event){
		this.step3=0;
		this.show2='';
		this.productwithsimilar=0;this.changesub=0;this.price=0; this.vprice=0;this.sprice=0;this.oprice=0;this.proprice=0;this.payprice=0;this.creprice=0;this.othprice=0;this.shopcart=0;this.acceptdon=0;this.strlocprice=0;this.prorate=0;
			
		this.product='';this.show3='';this.pm=''; this.vm='';this.shipp='';this.otrack='';this.prodret='';this.payp='';this.credeitca='';
		this.others='';this.shopvalue='';this.acceptvalue='';this.strloc='';this.proreview='';  //for ecommerce.......
		
		this.changeCmsPrice=0;this.pageprice=0;this.resprice=0;this.slideprice=0;this.photoprice=0;this.videoprice=0;this.seoprice=0;
		this.miltiLprice=0;this.emailprice=0;this.fprice=0;this.liveprice=0;this.calBprice=0;this.formSprice=0;this.regprice=0;
		this.fbprice=0;this.googlprice=0;this.linkprice=0;this.tweetprice=0;this.profprice=0;this.codeprice=0;this.mediaprice=0;
		this.delprice=0;this.anaprice=0;this.supportprice=0;this.forprice=0;this.val=0;  
		
		this.logods='';this.pageval='';this.response='';this.slidebanner='';this.formsubm='';this.photog='';this.videoembed='';
		this.Sfrnd='';this.multilingual='';this.emailnews='';this.forumval='';this.blogval='';this.livechat='';this.calenderbook='';this.bookform='';
		this.useregestration='';this.faceb='';this.googlep='';this.link='';this.twit='';this.profile='';this.w3co='';this.socialm='';
		this.expdel='';this.gogleanal='';this.supportfor=''; this.show4='';//for CMS...........
		
		this.htmlogval=0;this.htmlpage=0;this.htmlres=0;this.htmlbanner=0;this.htmlGalry=0;this.htmlvideo=0;this.htmlSEO=0;this.htmlW3C=0;
		this.hmlsocialm=0;this.expresval=0;this.googleanal=0;this.supportVal=0;  
		
		this.hLogoval='';this.htmlval='';this.htmldes='';this.htmlslide='';this.htmlphoto='';this.htmlvembed='';this.htmlsfrnd='';
		this.w3cValidate='';this.htmlsmedia='';this.htmldeli='';this.htmlgoogle='';this.htmlsup='';
		//for HTML......................
		
		this.demoval=0; this.demoval2=0; this.demoval3=0; this.demoval4=0; this.demoval5=0;
		this.demo1='';this.demo2='';this.demo3='';this.demo4='';this.demo5='';//for business.................
		
		for(var i=0;i<this.ar.length;i++){
			this.ar[i]=false;
		}
		if(event=='cust'){
			this.group=1;
			this.template=0;
			this.show1='Custom';
			this.logodesbol= false; 
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
			this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
            this.userregbol=false;
			this.psabol=false;
			this.vmbol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
			this.psadiffbol=false;
           this.monthchangebol=false;
           this.monthchangeothersbol=false;
           this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;

		}
		else if(event=='temp'){ 
			this.group=2;
    		//this.template=100;
			this.show1='Template';
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
			this.w3codebol=false;
			this.socialmediabol=false;
			this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
            this.userregbol=false;
			this.psabol=false;
			this.vmbol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
           this.monthchangebol=false;
           this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;

		}
		else{
			this.group=0;
			this.show1='';
		}
		//this.sumry.push(this.show1);
		
	}
	
	//use the function to find a single value of an array......
	inArray(needle, haystack) {
		var length = haystack.length;
		//console.log(needle);
		//console.log(haystack);
		for(var i = 0; i < length; i++) {
			if(haystack[i] == needle)
				return true;
		}
		return false;
	}
	
	//step 3.1// call the func when ecommerce of template click................
	changeTemp(event,pos,groupNo){
		this.show2='';
		//***************ECOMMERCE*********************************************************//
		this.productwithsimilar=0;this.changesub=0;this.price=0; this.vprice=0;this.sprice=0;
		this.oprice=0;this.proprice=0;this.shopcart=0;this.payprice=0;this.creprice=0;this.othprice=0;this.acceptdon=0;this.strlocprice=0;
		this.prorate=0;
					
		this.product='';this.show3='';this.pm=''; this.vm='';this.shipp='';this.otrack='';this.prodret='';this.payp='';this.credeitca='';
		this.others='';this.shopvalue='';this.acceptvalue='';this.strloc='';this.proreview='';
		
		//***************CMS*********************************************************//
		this.changeCmsPrice=0;this.pageprice=0;this.resprice=0;this.slideprice=0;this.photoprice=0;this.videoprice=0;this.seoprice=0;
		this.miltiLprice=0;this.emailprice=0;this.fprice=0; this.bprice=0;this.liveprice=0;this.calBprice=0;this.formSprice=0;this.regprice=0;
		this.fbprice=0;this.googlprice=0;this.linkprice=0;this.tweetprice=0;this.profprice=0;this.codeprice=0;this.mediaprice=0;
		this.delprice=0;this.anaprice=0;this.supportprice=0;this.forprice=0;this.val=0;
		
		this.logods='';this.pageval='';this.response='';this.slidebanner='';this.formsubm='';this.photog='';this.videoembed='';
		this.Sfrnd='';this.multilingual='';this.emailnews='';this.forumval='';this.blogval='';this.livechat='';this.calenderbook='';this.bookform='';
		this.useregestration='';this.faceb='';this.googlep='';this.link='';this.twit='';this.profile='';this.w3co='';this.socialm='';
		this.expdel='';this.gogleanal='';this.supportfor='';this.show4='';
		
		//******************************   HTML   ********************************************************//
		this.htmlogval=0;this.htmlpage=0;this.htmlres=0;this.htmlbanner=0;this.htmlGalry=0;this.htmlvideo=0;this.htmlSEO=0;this.htmlW3C=0;
		this.hmlsocialm=0;this.expresval=0;this.googleanal=0;this.supportVal=0;
		
		this.hLogoval='';this.htmlval='';this.htmldes='';this.htmlslide='';this.htmlphoto='';this.htmlvembed='';this.htmlsfrnd='';
		this.w3cValidate='';this.htmlsmedia='';this.htmldeli='';this.htmlgoogle='';this.htmlsup='';
		
		//***************        Business    *********************************************************//
		this.demoval=0;this.demoval2=0;this.demoval3=0;this.demoval4=0;this.demoval5=0;
		this.demo1='';this.demo2='';this.demo3='';this.demo4='';this.demo5='';
		
		for(var i=0;i<this.ar.length;i++){
			if(this.inArray(i,pos)) {
			   	this.ar[i]=true;
			   }
			else{
				this.ar[i]=false;
			}
		}
		var groupNo = groupNo;
		//console.log(event);
		if(event=='tempcms'){
			this.group=3;
			this.step3=1;
			this.show2='CMS';
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
             this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
            this.monthchangebol=false;
            this.monthchangeothersbol=false;
             this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;

		}
		else if(event=='temphtml'){
			this.group=8;
			//this.group=4;
			this.parentNo=2;
			this.step3=2;
			this.show2='HTML';
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
             this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
            this.monthchangebol=false;
            this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;


		}
		else if(event=='tempcom'){
			this.group=5;
			this.parentNo=3;
			this.step3=3;
			this.show2='eCommerce'
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
			this.w3codebol=false;
			this.socialmediabol=false;
			this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
             this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
            this.monthchangebol=false;
            this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;


		}
		else{
			this.group=0;
			this.step3=0;
			this.show2='';
			
		}
	}
	
	
	//step 3.2// call the func when ecommerce of custom click................
	changecust(event,pos,groupNo){
		//for cms.......................................
		this.pageprice=0;this.resprice=0;this.slideprice=0;this.photoprice=0;this.videoprice=0;this.seoprice=0;this.miltiLprice=0;
		this.emailprice=0;this.fprice=0;this.bprice=0;this.liveprice=0;this.calBprice=0;this.formSprice=0;this.regprice=0;this.fbprice=0;
		this.googlprice=0;this.linkprice=0;this.tweetprice=0;this.profprice=0;this.codeprice=0;this.mediaprice=0;this.delprice=0;
		this.anaprice=0;this.supportprice=0;this.forprice=0;this.val=0;
		
		this.show4='';this.logods='';this.pageval='';this.response='';this.slidebanner='';this.formsubm='';this.photog='';
		this.videoembed='';this.Sfrnd='';this.multilingual='';this.emailnews='';this.forumval=''; this.blogval='';this.livechat='';this.calenderbook='';
		this.bookform='';this.useregestration='';this.faceb='';this.googlep='';this.link='';this.twit='';this.profile='';this.w3co='';
		this.socialm='';this.expdel='';this.gogleanal='';this.supportfor='';
		
		//for ecommerce.................................
		this.productwithsimilar=0;this.price=0;this.sprice=0;this.oprice=0;this.proprice=0;this.payprice=0;this.creprice=0;this.othprice=0;
		this.shopcart=0;this.acceptdon=-0;this.strlocprice=0;this.prorate=0;
						
		this.product='';this.show3='';this.pm='';this.vm='';this.shipp='';this.otrack='';this.prodret='';this.payp='';this.credeitca='';
		this.others='';this.shopvalue='';this.acceptvalue='';this.strloc='';this.proreview='';
		
		//for html.....................................
		this.htmlogval=0;this.htmlpage=0;this.htmlres=0;this.htmlbanner=0;this.htmlGalry=0;this.htmlvideo=0;this.htmlSEO=0;this.htmlW3C=0;
		this.hmlsocialm=0;this.expresval=0;this.googleanal=0;this.supportVal=0;
		
		this.hLogoval='';this.htmlval='';this.htmldes='';this.htmlslide='';this.htmlphoto='';this.htmlvembed='';this.htmlsfrnd='';
		this.w3cValidate='';this.htmlsmedia='';this.htmldeli='';this.htmlgoogle='';this.htmlsup='';
		
		//for business.................................
		this.demoval=0;this.demoval2=0;this.demoval3=0;this.demoval4=0;this.demoval5=0;
		this.demo1='';this.demo2='';this.demo3='';this.demo4='';this.demo5='';
		
		for(var i=0;i<this.ar.length;i++){
			if(this.inArray(i,pos)) {
			   	this.ar[i]=true;
			   }
			else{
				this.ar[i]=false;
			}
		}
		var groupNo = groupNo;
		if(event=='custcms'){
			this.group=6;
			//this.step3=200;
			//this.step3=0;
			if(this.pageno){
				this.step3=(20*this.pageno);
			}else{
				this.step3=20;
			}
			this.show2='CMS';
			this.isplaceorderenabled=false; 
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
			this.w3codebol=false;
			this.socialmediabol=false;
			this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
            this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
            this.monthchangebol=false;
            this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;

		}
		else if(event=='custecom'){
			this.group=7;
			//this.step3=300;
			this.step3 = 2500;
			this.show2='eCommerce';
			this.isplaceorderenabled=false; 
            this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
            this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
            this.monthchangebol=false;
            this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;
		}
		else if(event=='custhtml'){
			this.group=8;
			this.step3=400;
			this.show2='HTML';
			this.isplaceorderenabled=false; 
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
            this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
            this.psadiffbol=false;
            this.monthchangebol=false;
            this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;
		}
		else if(event=='business'){
			this.group=9;
			this.step3=500;
			this.show2='Business Application';
		}
		else{
			this.group=0;
			this.step3=0
		}
	
	}
	
	//at first select template then ecommerce....then magento or woocomerce will come..
	//after woocomerce or zoomla clicked this function is called..............
	changeTempsub(event,pos,groupNo){
		console.log(pos);this.changesub=0;
		for(var i=0;i<this.ar.length;i++){
			if(this.inArray(i,pos)){
				//console.log(i,pos);
				//console.log(this.ar[i]);
				this.ar[i]=true;
			}
			else{
				this.ar[i]=false;
			}
		}
		
		if(event=='woocom'){ 
			this.group=7;
			this.changesub=50;
			this.show3='Woocommerce';
			this.isplaceorderenabled=false; 
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
             this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
        	this.psadiffbol=false;
           this.monthchangebol=false;
           this.monthchangeothersbol=false;
            this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;
		}
		else if(event=='magento'){
			this.group=7;
			this.changesub=20;
			this.show3='Magento';
			this.isplaceorderenabled=false; 
			 this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
			this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
			this.psadiffbol=false;

            this.monthchangebol=false;
            this.monthchangeothersbol=false;
             this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;

		}
	}
	
	//at first select template then cms....then zoomla or wordpress will come..
	//after wordpress or zoomla clicked... this function is called..............
	changeTempcmssub(event,pos,groupno){
		//console.log(pos);
		for(var i=0;i<this.ar.length;i++){
			if(this.inArray(i,pos)){
				//console.log(i,pos);
				//console.log(this.ar[i]);
				this.ar[i]=true;
			}
			else{
				this.ar[i]=false;
			}
		}
		
		if(event=='word'){
			this.group=6;
			this.changeCmsPrice=50;
			this.show4='WordPress';
			this.isplaceorderenabled=false; 
			 this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
			this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
			this.psadiffbol=false;
             this.monthchangebol=false;
             this.monthchangeothersbol=false;
              this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;
			

		} 
		else if(event=='Concrete5'){
			this.group=6;
			this.changeCmsPrice=70;
			this.show4='Concrete5';
			this.isplaceorderenabled=false; 
			this.logodesbol= false; // sittingbanbol
			this.pagedesignbol=false; 
			this.respondesbol=false; 
			this.sittingbanbol=false;
            this.formSubmckeckbox= false;
            this.photogalbol=false;
            this.videogalbol=false;
            this.seofrndbol=false;
            this.multisupportbol=false;
            this.emailnbol=false;
            this.forumbol=false;
            this.blogbol=false;
            this.livechbol=false;
            this.w3codebol=false;
            this.socialmediabol=false;
            this.delvalbol=false;
			this.goAnalbol=false;
			this.orderbol=false;
			this.proretbol=false;
			this.shopcartingbol=false;
			this.acceptdonationbol=false;
			this.useregistration=false;
			this.usebookingsystem=false;
			this.useshippingsystem=false;
			this.bookingsystembol=false;
            this.shippingsystembol=false;
			this.userregbol=false;
			this.vmbol=false;
			this.psabol=false;
			this.pmbol=false;
			this.paypalbol=false;
			this.otherpmbol=false;
			this.creditbol=false;
			this.storelocbol=false;
			this.productratebol=false;
			this.psadiffbol=false;
			this.monthchangebol=false;
			this.monthchangeothersbol=false;
			 this.custhtmlbol=false;
           this.custecombol=false;
           this.custcmsbol=false;
           this.tempbol=false;
           this.custbol=false;
           this.tempcmsbol=false;
           this.woocombol=false;
           this.magentbol=false;
           this.wordbol=false;
           this.Concrete5bol=false;
		}

	}
	prochange(event){
		this.productwithsimilar=0;
		
		if(event=='psa'){
			// this.productwithsimilar=100;
			this.productwithsimilar=150;
			this.product='Product With Similar Attributes';
			this.isplaceorderenabled=true;

		}
		else if(event=="5000"){
			//this.productwithsimilar=200;
			this.productwithsimilar=840;
			this.product='Product With Different Attributes';
			this.isplaceorderenabled=true;

		}else{

			this.productwithsimilar=0;
			this.product='';
		}
		console.log(this.product);
	}
	
	chk(isChecked:boolean){
		if(isChecked){
			//this.price=50;
			this.price=120;
			this.pm='Product Management';
		    this.isplaceorderenabled=true;

		}
		else{
			this.price=-120;
			this.pm='';
		}
	}

	vendorchk(isChecked:boolean){
		if(isChecked){
			this.vprice=600;
			this.vm='Vendor Management';
			this.isplaceorderenabled=true;

		}
		else{
			this.vprice=-600;
			this.vm='';
		}
	}
	
	shipping(event){
		this.sprice=0;
		console.log("ship",event);
		if(event=="flat"){
			this.sprice=60;
			this.shipp='Flat rate/ Free Shipping';
			this.isplaceorderenabled=true;

		}
		else {
			//console.log("integer");
			this.sprice=160;
			this.shipp='Integration With FedEx,UPS';
			this.isplaceorderenabled=true;

		}
	}
	order(isChecked:boolean){
		//console.log(isChecked);
		if(isChecked){
			this.oprice=360;
			this.otrack='Order Tracking';
			this.isplaceorderenabled=true;

			
		}
		else{
			this.oprice=-360;
			this.otrack='';
		}
	}
	
	proret(isChecked:boolean){
		console.log(isChecked);
		if(isChecked){
			this.proprice=300;
			this.prodret='Product Return';
		    this.isplaceorderenabled=true;

		}
		else{
			this.proprice=-300;
			this.prodret='';
		}
	}
	
	shopcarting(isChecked:boolean){
		console.log(isChecked);
		if(isChecked){
			this.shopcart=100;
			this.shopvalue='Shopping Cart';
		    this.isplaceorderenabled=true;

		}
		else{
			this.shopcart=-100;
			this.shopvalue='';
		}
	}
	
	acceptdonation(isChecked:boolean){
		console.log(isChecked);
		if(isChecked){
			this.acceptdon=50;
			this.acceptvalue='Accept Donation';
		    this.isplaceorderenabled=true;

		}
		else{
			this.acceptdon=-50;
			this.acceptvalue='';
		}
	}
	

	paypal(event){
		console.log(event);
		if(event==true){
			this.payprice=150;
			this.payp='Paypal';
			this.isplaceorderenabled=true;

		}
		else{
			this.payprice=-150;
			this.payp='';
		}
	}
	credit(isChecked){
		console.log(isChecked);
		if(isChecked){
			this.creprice=150;
			this.credeitca='Credit CardS';
		}
		else{
			this.creprice=-150;
			this.credeitca='';
		}
	}
	
	other(isChecked){
		//this.disabled=false;
//		var res=0;
//		res=this.result;
//		console.log(res);
//		if(isChecked){
//			this.othprice=res*100;
//			this.inputDisabled=true;
//		}
//		else{
//			this.othprice=res/100;
//			this.inputDisabled=false;
//		}
		if(isChecked){
			this.othprice=220;
			this.inputDisabled=true;
			//this.onChangeO(event);

			
		}
		else{
			this.othprice=-220;
			this.others='';
			this.inputDisabled=false;
		}
		
	}
	onChangeO(event){
		console.log(event.target.value);
		this.others=event.target.value;
	}

	storeloc(isChecked){
		if(isChecked){
			this.strlocprice=240;
			this.strloc='Store Locator';
			this.isplaceorderenabled=true;

		}
		else{
			this.strlocprice=-240;
			this.strloc='Store Locator';
		}
	}
	
	productrate(isChecked){
		if(isChecked){
			this.prorate=190;
			this.proreview='Product Rating & Reviews';
			this.isplaceorderenabled=true;

		}
		else{
			this.prorate=-190;
			this.proreview='';
		}
	}
	
	//after clicking cms.....
	//********************************************************************************************
	//this function is called for logo design..
	logodes(event){
		if(event==true){
			this.price=25;
			this.logods='Logo Design';
			this.isplaceorderenabled=true;
		}
		else{
			this.price=-25;
			this.logods='';
		}
	}
	//func is called for page design...................
	pagedesign(event){
		console.log(event);
		if(event==true){
			this.pageprice=(10*this.pageno);
			this.pageval='Page Design Mockup/Wireframe';
			this.isplaceorderenabled=true;
		}
		else{
			this.pageprice=-(10*this.pageno);
			this.pageval='';
		}
	}

	respondes(event){
		console.log(event);
		if(event == true){
			this.resprice=(10*this.pageno);
			this.response='Responsive Design';
			this.isplaceorderenabled=true;
		}
		else{
			this.resprice=-(10*this.pageno);
			this.response='';
		}
	}
	
	sittingban(event){
		if(event == true){
			this.slideprice=80;
			this.slidebanner='Sliding Banner';
			this.isplaceorderenabled=true;
		}
		else{
			this.slideprice=-80;
			this.slidebanner='';
		}
	}
	
	formSubm(event){
		if(event == true){
			this.forprice=40;
			this.formsubm='Form Submission';
			this.isplaceorderenabled=true;
			this.inputDisabled=true;
			//this.onChangeval(event);
		}
		else{
			this.forprice=-40;
			this.formsubm='';
			this.inputDisabled=false;
		}
	}
	onChangeval(event){
		console.log(event.target.value);
		//if(event.target.value>0){
		this.val=event.target.value;
	 // }
	}
	
	photogal(event){
		if(event == true){
			this.photoprice=60;
			this.photog="Photo Gallery";
			this.isplaceorderenabled=true;
		}
		else{
			this.photoprice=-60;
			this.photog='';
		}
	}
	
	videogal(event){
		if(event==true){
			this.videoprice=50;
			this.videoembed='Video Embedding Gallery';
			this.isplaceorderenabled=true;
		}
		else{
			this.videoprice=-50;
			this.videoembed='';
		}
	}
	
	seofrnd(event){
		if(event==true){
			this.seoprice=25;
			this.Sfrnd='SEO Friendly';
			this.isplaceorderenabled=true;
		}
		else{
			this.seoprice=-25;
			this.Sfrnd='';
		}
	}
	
	multisupport(event){
		if(event==true){
			if(this.pageno<=1 || this.pageno<=10){
				this.miltiLprice=50;

			}else{
               this.miltiLprice=80;

			}
			//this.miltiLprice=80;
			this.multilingual='Multilingual Support';
			this.isplaceorderenabled=true;
		}
		else{

			if(this.pageno<=1 || this.pageno<=10 ){
				this.miltiLprice=-50;

			}else{
               this.miltiLprice=-80;

			}
			//this.miltiLprice=-80;
			this.multilingual='';
		}
	}
	
	emailn(event){
		if(event==true){
			this.emailprice=90;
			this.emailnews='Email Newsletter';
			this.isplaceorderenabled=true;
		}
		else{
			this.emailprice=-90;
			this.emailnews='';
		}
	}
	
	forum(event){
		if(event==true){
			this.fprice=250;
			this.forumval='Forum';
			this.isplaceorderenabled=true;
		}
		else{
			this.fprice=-250;
			this.forumval='';
		}
	}

	blog(event){
		if(event==true){
			this.bprice=200;
			this.blogval='Blog';
			this.isplaceorderenabled=true;
		}
		else{
			this.bprice=-200;
			this.blogval='';
		}
	}
	
	livech(event){
		if(event==true){
			this.liveprice=25;
			this.livechat="Live Chat";
			this.isplaceorderenabled=true;
		}
		else{
			this.liveprice=-25;
			this.livechat='';
		}
	}
	//booking part
	calbook(event){
		if(event==true){
			this.calBprice=200;
			this.calenderbook='Calender Booking';
		}
		else{
			this.calBprice=-200;
			this.calenderbook='';
		}
	}
	
	formsub(event){
		if(event==true){
			this.formSprice=140;
			this.bookform='Form Submission';
		}
		else{
			this.formSprice=-140;
			this.bookform='';
		}
	}//end of booking part..............

	bookingsystem(event){
		if(event==true){
			this.usebookingsystem=true;
		}
		else{
			this.usebookingsystem=false;
		}
	}

	shippingsystem(event){
		//alert('khhh');
		if(event==true){
			this.useshippingsystem=true;
		}
		else{
			this.useshippingsystem=false;
		}
	}
	
	userreg(event){
		if(event==true){
			this.regprice=180;
			this.useregestration='User Registration';
			this.useregistration=true;

		}
		else{
			this.regprice=-180;
			this.useregestration='';

			this.faceb='';
			this.googlep='';
			this.link='';
			this.twit='';
			this.useregistration=false;
		}
	}
	//sign part
	signfb(event){
		if(event==true){
			this.fbprice=5;
			this.faceb='Facebook';
		}
		else{
			this.fbprice=-5;
			this.faceb='';

		}
	}
	signg(event){
		if(event==true){
			this.googlprice=5;
			this.googlep='Google Plus';
		}
		else{
			this.googlprice=-5;
			this.googlep='';
		}
	}
	signlink(event){
		if(event==true){
			this.linkprice=5;
			this.link='Linkedin';
		}
		else{
			this.linkprice=-5;
			this.link='';
		}
	}
	signT(event){
		if(event==true){
			this.tweetprice=5;
			this.twit='Twitter';
		}
		else{
			this.tweetprice=-5;
			this.twit='';
		}
	}
	signPro(event){
		if(event==true){
			this.profprice=5000;
			this.profile='Signup with Profile';
		}
		else{
			this.profprice=-5000;
			this.profile='';
		}
	}//end sign up part..........
	
	w3code(event){
		if(event==true){
			this.codeprice=50;
			this.w3co='W3C Validate Code';
		}
		else{
			this.codeprice=-50;
			this.w3co='';
		}
	}
	
	socialmedia(event){
		if(event==true){
			this.mediaprice=15;
			this.socialm='Social Media Sharing';
		}
		else{
			this.mediaprice=-15;
			this.socialm='';
		}
	}
	
	delval(event){
		if(event==true){
			this.delprice=8000;
			this.expdel='Express Delivery';
		}
		else{
			this.delprice=-8000;
			this.expdel='';
		}
	}
	
	goAnal(event){
		if(event==true){
			this.anaprice=15;
			this.gogleanal='Google Analytics';
		}
		else{
			this.anaprice=-15;
			this.gogleanal='';
		}
	}
	monthchange(event){
		if(event=='month1'){
			this.supportprice=0;
			this.supportfor='1 month Support';
		}
		else if(event=='month2'){
			this.supportprice=0;
			this.supportfor='2 months Support';
		}
		else if(event=='month3'){
			this.supportprice=3*150;
			this.supportfor='3 months Support';
		}
		else if(event=='month4'){
			this.supportprice=6*150;
			this.supportfor='6 months Support';
		}
		else if(event=='yr'){
			this.supportprice=12*150;
			this.supportfor='1 year Support';
		}else{

			this.supportprice=0;
			this.supportfor='';
		}
	}
	//after clicking html....
	//********************************************************************************************
	//this function is called for logo design..
	htmlogo(event){
		if(event.value==true){
			this.htmlogval=25;
			this.hLogoval='Logo Design';
			this.isplaceorderenabled=true;

		}
		else{
			this.htmlogval=-25;
			this.hLogoval='';
		}
	}
	//function call if 2nd option clicked ...............
	html_pro2(event){
		if(event.value==true){
			this.htmlpage=(10*this.pageno);
			this.htmlval='Page Design Mockup/wireframe';
			this.isplaceorderenabled=true;
		}
		else{
			this.htmlpage=-(10*this.pageno);
			this.htmlval='';
		}
	}
	//3rd option clicked...............
	html_pro3(event){
		if(event.value==true){
			this.htmlres=(10*this.pageno);
			this.htmldes='Responsive Design';
			this.isplaceorderenabled=true;
		}
		else{
			this.htmlres=-(10*this.pageno);
			this.htmldes='';
		}
	}

	html_pro4(event){
		if(event.value==true){
			this.htmlbanner=80;
			this.htmlslide='Sliding Banner';
			this.isplaceorderenabled=true;
		}
		else{
			this.htmlbanner=-80;
			this.htmlslide='';
		}
	}
	
	html_pro5(event){
		if(event.value==true){
			this.htmlGalry=60;
			this.htmlphoto='Photo Gallary';
			this.isplaceorderenabled=true;
		}
		else{
			this.htmlGalry=-60;
			this.htmlphoto='';
		}
	}
	
	html_pro6(event){
		if(event.value==true){
			this.htmlvideo=50;
			this.htmlvembed='Video Embedding Gallary';
			this.isplaceorderenabled=true;
		}
		else{
			this.htmlvideo=-50;
			this.htmlvembed='';
		}
	}
	
	html_pro7(event){
		if(event.value==true){
			this.htmlSEO=25;
			this.htmlsfrnd='SEO Friendly';
			this.isplaceorderenabled=true;
		}
		else{
			this.htmlSEO=-25;
			this.htmlsfrnd='';
		}
	}
	
	htmlW3(event){
		if(event==true){
			this.htmlW3C=50;
			this.w3cValidate='W3C Validate Code';
		}
		else{
			this.htmlW3C=-50;
			this.w3cValidate='';
		}
	}
	
	htmlsocial(event){
		if(event==true){
			this.hmlsocialm=15;
			this.htmlsmedia='Social Media Sharing';
		}
		else{
			this.hmlsocialm=-15;
			this.htmlsmedia='';
		}
	}
	
	htmlexp(event){
		if(event==true){
			this.expresval=3020;
			this.htmldeli='Express Delivery';
		}
		else{
			this.expresval=-3020;
			this.htmldeli='';
		}
	}
	
	htmlgogl(event){
		if(event==true){
			this.googleanal=15;
			this.htmlgoogle='Google Analytics';
		}	
		else{
			this.googleanal=-15;
			this.htmlgoogle='';
		}
	}
	
	supportchnge(event){
		if(event=='month1'){
			this.supportVal=0;
			this.htmlsup='1 month Support';
		}
		else if(event=='month2'){
			this.supportVal=0;
			this.htmlsup='2 months Support';
		}
		else if(event=='month3'){
			this.supportVal=(3*150);
			this.htmlsup='3 months Support';
		}
		else if(event=='month6'){
			this.supportVal=(6*150);
			this.htmlsup='6 months Support';
		}else if(event=='month12'){
                this.supportVal=(12*150);
			this.htmlsup='1 year Support';

		}
		else{
			 this.supportVal=0;
			this.htmlsup='';
		}
	}
	//*************************************************************************************************//	
	//after clicking business 
	//if first checkbox clicked this function call...........
	demo1fun(event){
		if(event==true){
			this.demoval=200;
			this.demo1='Demo Option1';
		}
		else {
			this.demoval=-200;
			this.demo1='';
		}
	}
	//after clicking 2nd checkbox called..........................
	demo2fun(event){
		if(event==true){
			this.demoval2=300;
			this.demo2='Demo Option2';
		}
		else{
			this.demoval2=-300;
			this.demo2='';
		}
	}
	//after clicking 3rd checkbox called............
	demo3fun(event){
		if(event==true){
			this.demoval3=400;
			this.demo3='Demo Option3';
		}
		else {
			this.demoval3=-400;
			this.demo3='';
		}
	}
	//after clicking 4th checkbox called................
	demo4fun(event){
		if(event==true){
			this.demoval4=500;
			this.demo4='Demo Option4';
		}
		else {
			this.demoval4=-500;
			this.demo4='';
		}
	}
	//after clicking 5th checkbox called...........
	demo5fun(event){
		if(event==true){
			this.demoval5=600;
			this.demo5='Demo option5';
		}
		else{
			this.demoval5=-600;
			this.demo5='';
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts